module.exports = __webpack_public_path__ + "static/media/Mobile-GenericBanner@1x.287f7b9f.png";